import { MatButton } from 'components/buttons'
import { Icon } from 'hello-design-system'

const SettingIconButton: React.FC<{ id: string; onClick?: React.MouseEventHandler<HTMLButtonElement> }> = ({ onClick, id }) => (
    <MatButton
        id={id}
        color='primary'
        className='button-in-active'
        onClick={onClick}
        variant='contained'
        width='56px'
        height='48px'
        borderRadius='48px'
    >
        <Icon width={24} iconName={'SettingsRounded'} />
    </MatButton>
)

export { SettingIconButton }
